import { Application } from "@hotwired/stimulus";
import DataLayerController from "./controllers/data_layer_controller";

const application = window.Stimulus || Application.start();

window.Stimulus = application;
application.register("data-layer", DataLayerController);
